import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import { CloudUpload, Close } from "@mui/icons-material";

const UploadHoroscope = ({ form, handleSingleImageUpload, setField }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Upload Horoscope Image
      </Typography>
      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => document.getElementById("horoscope-input")?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose an image (JPG/PNG)</Typography>
          <input
            id="horoscope-input"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            style={{ display: "none" }}
            onChange={(e) => handleSingleImageUpload(e, "horoscope")}
          />
        </CardContent>
      </Card>

      {form.horoscope && (
        <Stack direction="row" spacing={2} alignItems="center">
          <img
            src={form.horoscope.url}
            alt={form.horoscope.name}
            style={{
              width: 140,
              height: 140,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip label={form.horoscope.name} />
            <IconButton onClick={() => setField("horoscope", null)}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default UploadHoroscope;
